import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "preloader"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"preloader\"><div class=\"waviy\"><span>M</span><span>Y</span><span> </span><span>C</span><span>E</span><span>L</span><span>E</span><span>B</span><span>R</span><span>I</span><span>T</span><span>Y</span></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}